/* Progressive enhancement for the approved policy shell; native policy text remains readable without JS. */
(() => {
  'use strict';

  /** @param {Element} root */
  const enhancePolicy = (root) => {
    if (!(root instanceof HTMLElement) || root.dataset.policyEnhanced === 'true') return;
    root.dataset.policyEnhanced = 'true';

    const printButton = root.querySelector('[data-print]');
    if (printButton instanceof HTMLButtonElement) {
      printButton.hidden = false;
      printButton.addEventListener('click', () => window.print());
    }

    // Shopify privacy is displayed verbatim: do not add IDs or attributes inside it.
    if (root.querySelector('[data-native-privacy]')) return;
    const content = root.querySelector('[data-policy-content]');
    const contents = root.querySelector('[data-policy-toc]');
    const list = contents?.querySelector('.policy-toc__links');
    if (!content || !(contents instanceof HTMLDetailsElement) || !list) return;

    const headings = Array.from(content.querySelectorAll('h2')).filter((heading) => heading.textContent.trim());
    if (!headings.length) return;
    const title = root.querySelector('.policy-hero__title');
    const prefix = title?.id || 'B20Policy';
    const fragment = document.createDocumentFragment();
    let index = 0;

    for (const heading of headings) {
      index += 1;
      if (!heading.id) {
        let uniqueId = `${prefix}-chapter-${index}`;
        while (document.getElementById(uniqueId)) uniqueId += '-section';
        heading.id = uniqueId;
      }
      heading.tabIndex = -1;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.className = 'policy-toc__link';
      link.href = `#${encodeURIComponent(heading.id)}`;
      link.textContent = heading.textContent.trim();
      link.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        heading.focus({ preventScroll: true });
        heading.scrollIntoView({ behavior: 'instant', block: 'start' });
        const targetUrl = new URL(window.location.href);
        targetUrl.hash = heading.id;
        window.history.pushState({ ...window.history.state }, '', targetUrl); document.dispatchEvent(new CustomEvent('b21:fragment-change'));
      });
      item.append(link);
      fragment.append(item);
    }

    list.replaceChildren(fragment);
    contents.hidden = false;
    if (window.matchMedia('(min-width: 64rem)').matches) contents.open = true;
  };

  /** @param {Document|Element} scope */
  const enhanceWithin = (scope) => {
    if (scope instanceof Element && scope.matches('[data-b20-policy]')) enhancePolicy(scope);
    for (const root of scope.querySelectorAll('[data-b20-policy]')) enhancePolicy(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceWithin(document), { once: true });
  } else {
    enhanceWithin(document);
  }
  document.addEventListener('b21:content-ready', (event) => enhanceWithin(event.detail?.pane || document));
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target instanceof Element) enhanceWithin(event.target);
  });
})();

